import content from '../../content/homepage';
import { FeatureCard } from '../../components/FeatureCard';

export function FeatureList() {
  const { featureList } = content;

  return (
    <section
      id="features"
      aria-labelledby="features-heading"
      className="mx-auto max-w-7xl px-6 py-[var(--spacing-section-lg)] md:px-12 md:py-[var(--spacing-section-xl)]"
    >
      <h2
        id="features-heading"
        className="font-display mb-20 text-center text-5xl leading-tight font-medium md:mb-24 md:text-6xl lg:text-7xl"
      >
        {featureList.sectionHeading}
      </h2>

      <div className="flex flex-col gap-24 md:gap-32">
        {featureList.categories.map((category) => (
          <div key={category.id} aria-labelledby={`category-${category.id}-heading`}>
            <header className="mb-12 text-center md:mb-16">
              <h3
                id={`category-${category.id}-heading`}
                className="font-sans text-3xl font-normal tracking-[var(--tracking-title)] text-[color:var(--color-foreground)] uppercase md:text-4xl lg:text-5xl"
              >
                {category.name}
              </h3>
              <p className="mt-4 font-sans text-[14.64px] tracking-[var(--tracking-eyebrow)] text-[color:var(--color-muted)] uppercase md:text-[17.08px]">
                {category.tagline}
              </p>
              {category.note && (
                <p className="mt-1 font-sans text-[11px] tracking-[var(--tracking-button)] text-[color:var(--color-muted)] uppercase md:text-xs">
                  {category.note}
                </p>
              )}
            </header>

            <div className="grid grid-cols-1 gap-x-12 gap-y-4 md:grid-cols-2 lg:grid-cols-3">
              {category.features.map((feature) => (
                <FeatureCard
                  key={feature.name}
                  feature={feature}
                  roadmapBadgeLabel={featureList.roadmapBadgeLabel}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
